<template>
  <div class="add-basic-information">
    <!-- 收款信息 -->
    <div class="add-content">
      <div class="add-title" style="padding-left:0px">
        <span class="basic title-font-style">收款信息</span>
      </div>
      <el-form :model="queryParams" label-width="120px" :rules="supplierRules" ref="queryParams">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="供应商名称：">
              <span class="skip line-limit-length" @click="onEdit">{{this.$route.query.name}}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款类型：">
              <span>供应商活动返利</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款金额：" :rules="filter_rules({required:true})">
              <el-input-number
                v-model="queryParams.billMoney"
                :precision="2"
                :controls="false"
                style="width:100%"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-radio-group v-model="queryParams.receiptType" @change="handleChange">
            <el-form-item label="收款类型：" :rules="filter_rules({required:true})">
              <el-col :span="8" style="padding:0" v-for="item in checkboxGroupList" :key="item.id">
                <el-col :span="10">
                  <el-radio :label="item.label"></el-radio>
                </el-col>
              </el-col>
            </el-form-item>
          </el-radio-group>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="备注：" placeholder="可填写备注信息">
              <el-input type="textarea" :rows="3" v-model.trim="queryParams.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 银行转账账户 -->
    <div v-show="flagBrand === true" style="margin-top:20px;">
      <div class="add-content">
        <div class="add-title" style="padding-left:0px;">
          <span class="basic title-font-style">银行转账账户</span>
        </div>
        <el-form
          :model="queryParams"
          style="margin-left:15px"
          label-width="100px"
          :rules="supplierRules"
          ref="queryParams"
        >
          <el-row :gutter="20">
            <el-col :span="8" style='padding-left:0px;'>
              <el-form-item label="账户名称：">
                {{this.$route.query.name}}
                <el-button type="text" style="padding-left:20px;" @click="add">+添加账号</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6" style='padding-left:0px;'>
              <el-form-item label="银行账号：">
                <el-select
                  @change="changeSelect"
                  v-model.trim="queryParams.receiptBankNumber"
                  text-align="center"
                >
                  <el-option
                    v-for="(item,index) in list"
                    :key="index"
                    :label="item.bankCode"
                    :value="item.bankCode"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开户行：">
                <el-input v-model.trim="queryParams.receiptOpenBank" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="银行行号：">
                <el-input v-model.trim="queryParams.receiptOpenNumber" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 承兑汇票信息 -->
    <div v-show="flag === true" style="margin-top:20px;">
      <div class="add-content">
        <div class="add-title" style="padding-left:0px">
          <span class="basic title-font-style">承兑汇票信息</span>
        </div>
        <el-form :model="params" label-width="110px" :rules="supplierRules" ref="queryParams">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="承兑票号：" :rules="filter_rules({required:true})">
                <el-input v-model="params.billNumber" placeholder="请填写兑票号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出票单位：" :rules="filter_rules({required:true})">
                <el-input v-model="params.billCompany" placeholder="上海工控猫（电气）有限公司" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="出票行：" :rules="filter_rules({required:true})">
                <el-input v-model="params.billBank" placeholder="请填写出票行名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="出票日期：" :rules="filter_rules({required:true})">
                <el-date-picker
                  style="width:100%"
                  v-model="params.billDate"
                  type="date"
                  placeholder="选择日期："
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="到期日期：" :rules="filter_rules({required:true})">
                <el-date-picker
                  style="width:100%"
                  v-model="params.billEnddate"
                  type="date"
                  placeholder="选择日期："
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="upload-pictures">
            <el-col class="sealed-contract-uplaod">
              <el-form-item label="上传凭证：">
                <div class="upload-pictures">
                  <el-upload
                    action="/"
                    :on-success="allHandleSuccess"
                    :on-change="handleChanges"
                    :before-upload="beforeUploadFile"
                    :http-request="allUpload"
                    multiple
                    class="upload-demo"
                    drag
                    ref="upload"
                    :on-remove="handleRemove"
                    :on-exceed="onExceed"
                    :limit="1"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      将文件拖到此处，或
                      <em>点击上传</em>
                    </div>
                  </el-upload>
                </div>
                <div>支持上传pdf、jpg、png格式文件,单个文件大小不得超过10M，总文件大小不得超过200M（如单次上传多个文件，文件格式需一致）</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <!-------添加账号 -------------->
    <add-account ref="addAccountRefs" @onFrech="onFrech"></add-account>
    <!-- 申请收款 -->
    <el-dialog title="申请收款确认" :visible.sync="dialogVisible" width="30%">
      <div style="padding-left:30px">
        <div style="padding-bottom:10px">
          本次收款金额：
          <span style="color:red">{{queryParams.billMoney | priceFilterNum}}元</span>
        </div>
        <div style="padding-bottom:10px">收款方式：银行转账</div>
        <div style="padding-bottom:10px">确认提交收款申请?</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
    <div class="add-basic-information">
      <div style="text-align:left;margin:20px 0 0 40px;margin-left:54px;padding-bottom:20px;">
        <el-button type="primary" @click="apply">申请收款</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { checkboxGroupList } from './utils/data'
import addAccount from './dialog/addAccount'
import { financeUploadFile } from '@/api/fiance/fianceManage'
import { deepClone } from '@/util'
import { seeSupplierBank } from '@/api/supplier/supplierManage'

export default {
  components: {
    'add-account': addAccount
  },
  data () {
    return {
      ruleForm: [],
      suName: '',
      list: [],
      dialogVisible: false,
      uploadFileType: ['pdf', 'png', 'jpg', 'jpeg'],
      fileList: [],
      queryParams: {
        billMoney: 0.0,
        receiptType: '银行转账'
      },
      expressionList: [],
      params: {},
      supplierRules: {
        productClass: [{ required: true }],
        proType: [{ required: true }]
      }, // 校验规则
      checkboxGroupList: [],
      flag: false,
      flagBrand: true,
      startTime: '', // 出票日期
      endTime: '', // 到期日期
      fileName: '' // 文件名
    }
  },
  created () {
    this.checkboxGroupList = checkboxGroupList
    this.getBank()
  },
  methods: {
    onFrech () {
      seeSupplierBank(this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.list = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 供应商跳转页面
    onEdit () {
      this.$router.push({
        path: '/crm/supplier/supplierEdit',
        query: { id: this.$route.query.id }
      })
    },
    onExceed () {
      this.$message.error('至多上传1个文件！')
    },
    handleRemove (file) {
      this.fileList = this.fileList.filter(item => {
        return item.id !== file.id
      })
      this.ruleForm = this.ruleForm.filter(items => {
        return items.guid !== file.id
      })
      this.$message.success('删除成功')
    },
    beforeUploadFile (file, fileList) {
      const { uploadFileType } = this
      const filearr = file.name.split('.')
      const filetype = filearr[filearr.length - 1]
      if (file.size === 0) {
        this.$message.error('文件内容为空')
        return false
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件过大')
        return false
      }
      if (uploadFileType.includes(filetype)) {
        return true
      }
      this.$message.error('请上传正确的文件')
      return false
    },
    // 上传
    async allUpload () {
      var formData = new FormData()
      const { fileList } = this
      const len = fileList.length - 1
      formData.append('MultipartFile[]', fileList[len].raw)
      await financeUploadFile(formData).then(res => {
        if (res.data.code === 200) {
          this.ruleForm.push(...res.data.obj)
          Object.assign(this.fileList[len], {
            id: res.data.obj[0].guid
          })
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleChanges (file, fileList) {
      this.fileList = fileList
    },
    allHandleSuccess () {
      this.$message.success('上传成功')
    },
    handleChange (value) {
      if (value === '银行转账') {
        this.flagBrand = true
        this.flag = false
      } else if (value === '承兑汇票') {
        this.flag = true
        this.flagBrand = false
      } else {
        this.flag = false
        this.flagBrand = false
      }
    },
    // 添加账户
    add () {
      this.$refs.addAccountRefs.onInitialize(
        this.$route.query.name,
        this.$route.query.id
      )
    },
    // 获取银行账号
    getBank () {
      seeSupplierBank(this.$route.query.id)
        .then(res => {
          if (res.data.code === 200) {
            this.list = res.data.obj
            // if (!this.$route.query.id && this.list !== null) {
            this.queryParams.receiptOpenNumber = this.list[0].bankOpenCode
            this.queryParams.receiptOpenBank = this.list[0].bankOpencount
            this.queryParams.receiptBankNumber = this.list[0].bankCode
            // }
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 银行账号下拉框联动
    changeSelect (id) {
      // 银行账号下拉框
      const obj = this.list.filter(
        ele => ele.bankCode === this.queryParams.receiptBankNumber
      )[0]
      this.queryParams.receiptOpenNumber = obj.bankOpenCode
      this.queryParams.receiptOpenBank = obj.bankOpencount
      this.queryParams.receiptName = obj.cusName
      this.queryParams = deepClone(this.queryParams)
    },
    // 申请收款
    apply () {
      if (!this.queryParams.billMoney || this.queryParams.billMoney < 0) {
        this.$message.error('请输入正确的收款金额')
      } else {
        if (this.queryParams.receiptType === '承兑汇票') {
          if (
            !this.params.billNumber ||
            !this.params.billBank ||
            !this.params.billDate ||
            !this.params.billEnddate
          ) {
            this.$message.error('申请失败,必填项不可为空')
          } else {
            this.dialogVisible = true
          }
        } else {
          this.dialogVisible = true
        }
      }
    },
    // 提交收款
    confirm () {
      this.params.financePayRequestAttachmentList = this.ruleForm.map(item => {
        return Object.assign(item, {
          attachment: item.guid
        })
      })
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    }
  }
}
</script>

<style lang="scss" scoped>
.add-content {
  background-color: #fff;
  padding: 0 20px !important;
}
</style>
